(function () {
  if (typeof Lenis === 'undefined') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  if (prefersReducedMotion || isDesignMode) return;

  function getHeaderOffset() {
    const height = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    return Number.isFinite(height) ? height : 80;
  }

  function isScrollLocked() {
    return Array.from(document.body.classList).some((className) => className.startsWith('overflow-hidden'));
  }

  const lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
    syncTouch: false,
  });

  document.documentElement.style.scrollPaddingTop = `${getHeaderOffset()}px`;

  function scrollToHash(hash, immediate = false) {
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    lenis.scrollTo(target, { offset: -getHeaderOffset(), immediate });
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

      const hash = url.hash;
      if (!hash || hash === '#') return;

      if (!document.querySelector(hash)) return;

      event.preventDefault();
      scrollToHash(hash);
      history.pushState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
    },
    true
  );

  function onRaf(time) {
    lenis.raf(time);
    requestAnimationFrame(onRaf);
  }

  requestAnimationFrame(onRaf);

  if (window.location.hash) {
    requestAnimationFrame(() => scrollToHash(window.location.hash, true));
  }

  window.addEventListener('hashchange', () => {
    scrollToHash(window.location.hash);
  });

  if (isScrollLocked()) lenis.stop();

  const bodyObserver = new MutationObserver(() => {
    if (isScrollLocked()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  window.addEventListener(
    'resize',
    () => {
      document.documentElement.style.scrollPaddingTop = `${getHeaderOffset()}px`;
      lenis.resize();
    },
    { passive: true }
  );

  // Google Translate / late layout growth — refresh Lenis scroll limits
  // so Spanish (taller) pages can reach the footer.
  let resizeTimer = null;
  function queueLenisResize() {
    if (resizeTimer !== null) return;
    resizeTimer = window.setTimeout(function () {
      resizeTimer = null;
      lenis.resize();
    }, 120);
  }

  if (typeof ResizeObserver !== 'undefined') {
    const heightObserver = new ResizeObserver(queueLenisResize);
    heightObserver.observe(document.documentElement);
    if (document.body) heightObserver.observe(document.body);
    const main = document.getElementById('MainContent');
    if (main) heightObserver.observe(main);
  }

  const classObserver = new MutationObserver(queueLenisResize);
  classObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'lang'],
  });

  window.addEventListener('load', function () {
    queueLenisResize();
    setTimeout(queueLenisResize, 500);
    setTimeout(queueLenisResize, 1500);
    setTimeout(queueLenisResize, 3000);
  });

  window.prepteraLenis = lenis;
  window.prepteraLenisResize = queueLenisResize;
})();
